import Input from "../../../Medicine-master/Component/Input";
 
export const TestPackagesInputs = [
  {
    tag: Input,
    img: "",
    label: "Package Name",
    name: "packageName",
    validation: "required",
    required: true,
    key: "packageName",
  },
  {
    tag: Input,
    img: "",
    label: "Price(₹)",
    name: "price",
    validation: "required",
    required: true,
    key: "price",
  },
  {
    tag: Input,
    img: "",
    label: "Discount",
    name: "discount",
    validation: "required",
    required: true,
    key: "discount",
  },
  {
    tag: Input,
    img: "",
    label: "Validity Period",
    name: "validityPeriod",
    validation: "required",
    required: true,
    key: "validityPeriod",
  },
];
 
